<script setup lang="ts">
const emits = defineEmits<{
  click: [MouseEvent]
}>()
const openTypeform = (e: MouseEvent) => {
  emits('click', e)
  document?.getElementById('inquiry-typeform')?.click()
}
</script>

<template>
  <div class="bg-beige p-4">
    <h4 class="mb-1 text-lg">
      {{ $t('inquiry.success.weValueYourFeedback') }}
    </h4>
    <div class="mb-1">
      {{ $t('inquiry.success.whatDidYouThink') }}
    </div>
    <BaseButton color="black" variant="link" @click="openTypeform">
      {{ $t('inquiry.success.giveFeedback') }}
    </BaseButton>
  </div>
</template>
